module.exports = __webpack_public_path__ + "static/media/banner.54505293.png";